import { ENV } from "./constants/env";

const mediaEndpoints = {
    uploadFile: "/api/s3/objects/files",
};

// Strings
const stringsEndpoints = {
    listStrings: "/api/strings/stringslist",
    createString: "/api/strings/add-string",
    updateString: "/api/strings/update",
    deleteString: "/api/strings/delete-string",
    mutlipleActionsStrings: "/api/strings/multi-action",
};

// Promotions
const promotionsEndpoints = {
    listPromotions: "/api/promotions",
    createPromotion: "/api/promotions",
    updatePromotion: "/api/promotions",
    deletePromotion: "/api/promotions",
};

// Dashboard users
const usersEndpoints = {
    listUsers: "/api/dashboard/userlist",
    createUser: "/api/dashboard/create-user",
    updateUser: "/api/dashboard/update-user",
    sendUserResetPasswordEmail: "/api/dashboard/forgot-password",
};

const eventsEndpoints = {
    getEventsData: "/api/events/eventslist",
};

const leadsEndpoints = {
    getLeadById: "/api/leads/find",
};

const offersEndpoints = {
    getOffersList: "/api/offers/",
    getOfferTemplates: "/api/offers/list-templates",
    getOfferTemplateById: "/api/offers/find-template",
    createOffer: "/api/offers/create-offer",
    getOfferById: "/api/offers/find-offer",
};

const callsServiceHost = "https://calls-prod.elithair.tech/api";
const offersServiceHerokuHost = "https://offer-services.herokuapp.com";
const treatmentsServiceBaseUrl = "https://treatment-svc-33fcc29d66d1.herokuapp.com/treatment-svc";
const prpSessionFeedbacServiceBaseUrl = "https://prod.v2.api.elithair.tech";
const calcPanelServiceBaseUrl = "https://calc-panel-4c5959ecc96e.herokuapp.com";
const templates = "templates";
const sections = "sections";
//  const offersServiceHerokuHost = 'http://localhost:5001';
// const callsServiceHost = 'http://localhost:8002/api';

const getPrpSessionFeedbackEndpoints = {
    getPrpSessionFeedbackList: `${prpSessionFeedbacServiceBaseUrl}/api/feedback`,
};

const calcPanelEndpoints = {
    getCalcPanelById: `${calcPanelServiceBaseUrl}/calc`,
    getCalcPanelList: `${calcPanelServiceBaseUrl}/calc/list`,
    updateCalcPanel: `${calcPanelServiceBaseUrl}/calc/update`,
    deleteCalcPanel: `${calcPanelServiceBaseUrl}/calc/delete`,
    activateCalcPanel: `${calcPanelServiceBaseUrl}/calc/activate`,
};

const twilioEndpoints = {
    // getCallsList: '/twilio',
    getCallsList: `${callsServiceHost}/twilio/?prefix=CallMachine_CA&limit=1000`,
    getCallById: `${callsServiceHost}/twilio`,
};

const machineCallerEndpoints = {
    postMachineCallerList: `${callsServiceHost}/machine-caller`,
    getMachineCallerScripts: `${callsServiceHost}/machine-caller/scripts`,
    getMachineCallerState: `${callsServiceHost}/machine-caller/status`,
    postStartMachineCaller: `${callsServiceHost}/machine-caller/start`,
    postStopMachineCaller: `${callsServiceHost}/machine-caller/stop`,
    getMachineCalls: `${callsServiceHost}/machine-caller?prefix=CallMachine_CA&limit=1000`,
    getMachineCallById: `${callsServiceHost}/machine-caller`,
};

const templatesEndpoints = {
    getTemplateList: `${offersServiceHerokuHost}/${templates}`,
    getTemplateContent: `${offersServiceHerokuHost}/${templates}/template-content`,
    getTemplateContentWithSection: `${offersServiceHerokuHost}/${templates}/template-raw-content`,
    createOffer: `${offersServiceHerokuHost}/generate-offer`,
    deleteTemplate: `${offersServiceHerokuHost}/${templates}`,
    createTemplate: `${offersServiceHerokuHost}/${templates}`,
    updateTemplate: `${offersServiceHerokuHost}/${templates}`,
    submitTemplate: `${offersServiceHerokuHost}/${templates}/submit`,
    updateTemplateContent: `${offersServiceHerokuHost}/update-template-content-by-template-and-contentid`,
};

const sectionssEndpoints = {
    getSections: `${offersServiceHerokuHost}/${sections}`,
    getSectionsList: `${offersServiceHerokuHost}/${sections}`,
    deleteSection: `${offersServiceHerokuHost}/${sections}`,
    getSectionVersions: `${offersServiceHerokuHost}/${sections}/section-versions-and-contents`,
    updateSection: `${offersServiceHerokuHost}/${sections}`,
    createSection: `${offersServiceHerokuHost}/${sections}`,
    getLatestVersionSections: `${offersServiceHerokuHost}/${sections}/latest-version-sections`,
    updateToLatestVersionSectionsInTemplateContent: `${offersServiceHerokuHost}/${sections}/update-sections-in-template-content`,
};

const extraTreatmentsEndpoints = {
    getExtraTreatments: `${treatmentsServiceBaseUrl}/treatment/list`,
    createExtraTreatment: `${treatmentsServiceBaseUrl}/treatment/create`,
    updateExtraTreatment: `${treatmentsServiceBaseUrl}/treatment/update`,
    deleteExtraTreatment: `${treatmentsServiceBaseUrl}/treatment`,
};

// Auth Service Endpoints
const authServiceBaseUrl = `${ENV.ELITHAIR_API_URL.v2}/auth-svc`;

export const authEndpoints = {
    register: `${authServiceBaseUrl}/auth/register`,
    login: `${authServiceBaseUrl}/auth/login`,
    validateToken: `${authServiceBaseUrl}/auth/validate-token`,
    refreshToken: `${authServiceBaseUrl}/auth/token`,
    me: `${authServiceBaseUrl}/user/me`,
    userList: `${authServiceBaseUrl}/user/list`,
    userById: (id: string) => `${authServiceBaseUrl}/user/${id}`,
    deleteUser: (id: string) => `${authServiceBaseUrl}/user/${id}`,
    exchangeCode: `${authServiceBaseUrl}/auth/sso/exchange-code`,
    ssoLogin: `${authServiceBaseUrl}/auth/sso/login`,
    permissionGroups: `${authServiceBaseUrl}/permission/groups`,
    createPermissionGroup: `${authServiceBaseUrl}/permission/groups`,
    updatePermissionGroup: (id: string) => `${authServiceBaseUrl}/permission/groups/${id}`,
    deletePermissionGroup: (id: string) => `${authServiceBaseUrl}/permission/groups/${id}`,
    permissionCodes: `${authServiceBaseUrl}/permission/codes`,
};

// --- ElitAI endpoints ---
const elitaiServiceBaseUrl = ENV.ELITHAIR_API_URL.v2;
export const elitaiEndpoints = {
    simulation: `${elitaiServiceBaseUrl}/elitai-svc/simulation`,
    simulationBulk: `${elitaiServiceBaseUrl}/elitai-svc/simulation/bulk`,
    simulationExport: `${elitaiServiceBaseUrl}/elitai-svc/simulation/export`,
};

// --- Prompts endpoints ---

const promptsServiceBaseUrl = `${ENV.ELITHAIR_API_URL.v2}/misc-svc`;
export const promptsEndpoints = {
    listPrompts: `${promptsServiceBaseUrl}/prompt`,
    createPrompt: `${promptsServiceBaseUrl}/prompt`,
    getPromptById: (id: string) => `${promptsServiceBaseUrl}/prompt/${id}`,
    updatePrompt: (id: string) => `${promptsServiceBaseUrl}/prompt/${id}`,
    deletePrompt: (id: string) => `${promptsServiceBaseUrl}/prompt/${id}`,
};

// --- Tutorials endpoints ---
const tutorialsServiceBaseUrl = `${ENV.ELITHAIR_API_URL.v2}/app-svc`;
export const tutorialsEndpoints = {
    listTutorials: `${tutorialsServiceBaseUrl}/tutorials`,
    getTutorialById: (id: string) => `${tutorialsServiceBaseUrl}/tutorials/${id}`,
    createTutorial: `${tutorialsServiceBaseUrl}/tutorials`,
    updateTutorial: (id: string) => `${tutorialsServiceBaseUrl}/tutorials/${id}`,
    deleteTutorial: (id: string) => `${tutorialsServiceBaseUrl}/tutorials/${id}`,
};

// --- Shortlinks endpoints ---
const shortlinksServiceBaseUrl = `${ENV.ELITHAIR_API_URL.v2}/misc-svc`;
export const shortlinksEndpoints = {
    listShortlinks: (page: number = 1, limit: number = 25, search: string = "") =>
        `${shortlinksServiceBaseUrl}/shortlinks/list?page=${page}&limit=${limit}${search ? `&search=${encodeURIComponent(search)}` : ""}`,
    getShortlinkById: (id: string) => `${shortlinksServiceBaseUrl}/shortlinks/${id}`,
    createShortlink: `${shortlinksServiceBaseUrl}/shortlinks`,
    createCustomShortlink: `${shortlinksServiceBaseUrl}/shortlinks/custom`,
    updateShortlink: (id: string) => `${shortlinksServiceBaseUrl}/shortlinks/${id}`,
    updateCustomShortlink: (id: string) => `${shortlinksServiceBaseUrl}/shortlinks/custom/${id}`,
    deleteShortlink: (id: string) => `${shortlinksServiceBaseUrl}/shortlinks/${id}`,
    getLeadByEmail: (email: string) => `${shortlinksServiceBaseUrl}/leads/email/${email}`,
};

// --- UTM Sources endpoints ---
export const utmSourceEndpoints = {
    listUtmSources: `${shortlinksServiceBaseUrl}/utm-sources`,
    listAllUtmSources: `${shortlinksServiceBaseUrl}/utm-sources/list/all`,
    getUtmSourceById: (id: string) => `${shortlinksServiceBaseUrl}/utm-sources/${id}`,
    createUtmSource: `${shortlinksServiceBaseUrl}/utm-sources`,
    updateUtmSource: (id: string) => `${shortlinksServiceBaseUrl}/utm-sources/${id}`,
    deleteUtmSource: (id: string) => `${shortlinksServiceBaseUrl}/utm-sources/${id}`,
};

// --- UTM Mediums endpoints ---
export const utmMediumEndpoints = {
    listUtmMediums: `${shortlinksServiceBaseUrl}/utm-mediums`,
    listAllUtmMediums: `${shortlinksServiceBaseUrl}/utm-mediums/list/all`,
    getUtmMediumById: (id: string) => `${shortlinksServiceBaseUrl}/utm-mediums/${id}`,
    createUtmMedium: `${shortlinksServiceBaseUrl}/utm-mediums`,
    updateUtmMedium: (id: string) => `${shortlinksServiceBaseUrl}/utm-mediums/${id}`,
    deleteUtmMedium: (id: string) => `${shortlinksServiceBaseUrl}/utm-mediums/${id}`,
};

// --- Patients endpoints ---
const patientsServiceBaseUrl = `${ENV.ELITHAIR_API_URL.v2}/patients-svc`;
export const patientsEndpoints = {
    listPatients: `${patientsServiceBaseUrl}/patients/list?`,
    getPatientById: `${patientsServiceBaseUrl}/patients`,
    updatePatient: `${patientsServiceBaseUrl}/patients`,
    listPatientEvents: `${patientsServiceBaseUrl}/patients/events`,
    sendPatientResetPasswordEmail: `${patientsServiceBaseUrl}/patients/reset-password`,
};

// TODO: Do not add more endpoints to this object, please
// prefer to create a new object and export it directly
// try to group the endpoints by the service they belong to
const endpoints = {
    ...mediaEndpoints,
    ...stringsEndpoints,
    ...promotionsEndpoints,
    ...getPrpSessionFeedbackEndpoints,
    ...usersEndpoints,
    ...leadsEndpoints,
    ...offersEndpoints,
    ...twilioEndpoints,
    ...calcPanelEndpoints,
    ...machineCallerEndpoints,
    ...eventsEndpoints,
    ...templatesEndpoints,
    ...sectionssEndpoints,
    ...extraTreatmentsEndpoints,
    ...authEndpoints,
    ...patientsEndpoints,
    ...shortlinksEndpoints,
    ...utmSourceEndpoints,
    ...utmMediumEndpoints,
};

export default endpoints;
